import nextId from "react-id-generator"
import drmartens15 from "../../images/drmartens15.png"
import drmartens16 from "../../images/drmartens16.png"
import drmartens17 from "../../images/drmartens17.png"
import drmartens18 from "../../images/drmartens18.png"
import drmartens19 from "../../images/drmartens19.png"
import drmartens20 from "../../images/drmartens20.png"
import drmartens21 from "../../images/drmartens21.png"
import drmartens22 from "../../images/drmartens22.png"
import drmartens23 from "../../images/drmartens22.png"
import drmartens24 from "../../images/drmartens24.png"
import drmartens26 from "../../images/drmartens26.png"
import drmartens27 from "../../images/drmartens27.png"
import drmartens29 from "../../images/drmartens29.png"
import drmartens31 from "../../images/drmartens31.png"
import drmartens2 from "../../images/drmartens2.png"

export const shopItems = [
    {
        id: nextId(),
        image: drmartens15,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens16,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens17,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens18,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens19,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens20,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens21,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens22,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens23,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens24,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens26,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens27,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens29,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens31,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens2,
        name: "dr martens boots",
        price: "£199.99"
    },
    
]